'use client'

import { Check } from "lucide-react"

type StepIndicatorProps = {
  steps: string[]
  currentStep: number
}

export function StepIndicatorComponent({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="w-full py-3">
      <div className="relative">
        {/* Labels row - positioned above */}
        <div className="flex items-center mb-2">
          {steps.map((step, index) => {
            const isCompleted = index < currentStep
            const isActive = index === currentStep

            return (
              <div key={step} className="relative flex-1 flex flex-col items-center">
                {/* Step Label */}
                <span
                  className={`text-xs transition-colors duration-200 relative z-20 ${
                    isActive
                      ? 'text-gray-900 font-medium'
                      : isCompleted
                        ? 'text-gray-600'
                        : 'text-gray-400'
                  }`}
                >
                  {step}
                </span>
              </div>
            )
          })}
        </div>

        {/* Circles and connecting line row */}
        <div className="relative flex items-center">
          {/* Background connecting line */}
          <div className="absolute top-3 left-0 right-0 h-px bg-gray-200 z-0" />
          
          {/* Progress line */}
          <div
            className="absolute top-3 left-0 h-px bg-blue-500 transition-all duration-300 ease-out z-[1]"
            style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
          />

          {steps.map((step, index) => {
            const isCompleted = index < currentStep
            const isActive = index === currentStep

            return (
              <div key={step} className="relative z-10 flex-1 flex justify-center">
                {/* Step Circle */}
                <div
                  className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium transition-colors duration-200 relative z-10 ${
                    isCompleted
                      ? 'bg-blue-500 text-white'
                      : isActive
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-200 text-gray-500'
                  }`}
                >
                  {isCompleted ? (
                    <Check className="w-3 h-3" />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}